import React, { useEffect, useState } from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import ButtonComp from "@components/UI/Button/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';
import { useFetchDataProcessos } from '@hooks/api/Processo/useFetchDataProcessos.js';
import { tipoComplianceOptions } from "@enums/Compliance/Index.jsx";
import InputDatePickerComp from '@components/UI/InputDatePicker/Index.jsx';
import { statusAuditoriaUnidadeGerenciaOptions } from '@components/UI/StatusSolicitacao/Index.jsx';
import dayjs from 'dayjs';

const FilterSolicitacaoUnidadeGerencia = ({ setFilters }) => {

    const [tempValues, setTempValues] = useState({
        tipoCompliance: "",
        numeroSolicitacao: "",
        dataSolicitacaoInicial: "",
        dataSolicitacaoFinal: "",
        nomeProcesso: "",
        statusSolicitacao: null,
    });

    const {
        processosOptions,
        processosLoading,
        fetchProcessos,
    } = useFetchDataProcessos();

    useEffect(() => {
        fetchProcessos();
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();

        setFilters({
            tipoCompliance: tempValues.tipoCompliance?.value,
            numeroSolicitacao: tempValues.numeroSolicitacao,
            dataSolicitacaoInicial: tempValues.dataSolicitacaoInicial,
            dataSolicitacaoFinal: tempValues.dataSolicitacaoFinal,
            nomeProcesso: tempValues.nomeProcesso?.label,
            statusSolicitacao: tempValues.statusSolicitacao?.value,
        });
    };

    const handleClearFilter = () => {
        setFilters({
            tipoCompliance: "",
            numeroSolicitacao: "",
            dataSolicitacaoInicial: "",
            dataSolicitacaoFinal: "",
            nomeProcesso: "",
            statusSolicitacao: null,
        });
        setTempValues({
            tipoCompliance: "",
            numeroSolicitacao: "",
            dataSolicitacaoInicial: "",
            dataSolicitacaoFinal: "",
            nomeProcesso: "",
            statusSolicitacao: null,
        });
    };

    const handleTempChange = (field, value) => {
        setTempValues((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // Ajuste para o Input de Nº da Solicitação
    const handleSolicitacaoInput = (e) => {
        const value = e.target.value.replace(/-/g, '').toUpperCase();

        const part1 = value.slice(0, 3);
        const part2 = value.slice(3, 6);
        const part3 = value.slice(6, 10);
        const part4 = value.slice(10, 13);

        const formatted = [part1, part2, part3, part4].filter(part => part).join('-');

        handleTempChange("numeroSolicitacao", formatted);
    };


    return (
        <form onSubmit={handleSearch} className="form">
            <div className='col-md-12'>
                <div className="row">

                    {/* Coluna Esquerda */}
                    <div className='col-md-8 mt-2'>
                        <SelectOptionComp
                            label="Compliance"
                            options={tipoComplianceOptions}
                            value={tempValues.tipoCompliance}
                            onChange={(selected) => handleTempChange("tipoCompliance", selected)}
                            placeholder={"Selecionar um compliance"}
                            hoverMessage="Selecionar um compliance"
                        />

                        <InputTextComp
                            label="Nº Da Solicitação"
                            name="numeroSolicitacao"
                            value={tempValues.numeroSolicitacao}
                            onChange={handleSolicitacaoInput}
                            placeholder={"Preencher com o número da solicitação."}
                            hoverMessage="Preencher com o número da solicitação. O sistema insere automaticamente os hífens nos locais corretos."
                            maxLength={16}
                        />

                        <div className='d-flex'>
                            <div className='col-md-6'>
                                <InputDatePickerComp
                                    label="Data Inicial Criação"
                                    name="dataSolicitacaoInicial"
                                    value={
                                        tempValues.dataSolicitacaoInicial
                                            ? dayjs(tempValues.dataSolicitacaoInicial, "YYYY-MM-DD")
                                            : null
                                    }
                                    placeholder="Selecionar"
                                    hoverMessage="Clique no ícone ao lado para selecionar uma data."
                                    format="DD/MM/YYYY"
                                    showToday={false}
                                    onChange={(selected) =>
                                        handleTempChange("dataSolicitacaoInicial", selected ? selected.format("YYYY-MM-DD") : "")
                                    }
                                />
                            </div>

                            <div className='col-md-6'>
                                <InputDatePickerComp
                                    label="Data Final Criação"
                                    name="dataSolicitacaoFinal"
                                    value={
                                        tempValues.dataSolicitacaoFinal
                                            ? dayjs(tempValues.dataSolicitacaoFinal, "YYYY-MM-DD")
                                            : null
                                    }
                                    placeholder="Selecionar"
                                    hoverMessage="Clique no ícone ao lado para selecionar uma data."
                                    format="DD/MM/YYYY"
                                    showToday={false}
                                    onChange={(selected) =>
                                        handleTempChange("dataSolicitacaoFinal", selected ? selected.format("YYYY-MM-DD") : "")
                                    }
                                />
                            </div>
                        </div>

                        <SelectOptionComp
                            label="Processo"
                            options={processosOptions}
                            value={tempValues.nomeProcesso}
                            onChange={(selected) => handleTempChange("nomeProcesso", selected)}
                            placeholder={"Selecionar um processo"}
                            hoverMessage="Selecionar um processo"
                            isLoading={processosLoading}
                        />

                        <SelectOptionComp
                            label="Status"
                            options={statusAuditoriaUnidadeGerenciaOptions}
                            value={tempValues.statusSolicitacao}
                            onChange={(selected) => handleTempChange("statusSolicitacao", selected)}
                            placeholder={"Selecionar um status"}
                            hoverMessage="Selecionar um status"
                        />
                    </div>

                    {/* Botões de Ação */}
                    <div className="col-8 col-md-8 d-flex flex-wrap justify-content-end mt-4">
                        <ButtonComp
                            onClick={handleSearch}
                            title="Aplicar filtro"
                            buttonColor="#2b97be"
                            classnameIcon="fa-solid fa-filter"
                            hoverMessage={"Botão para aplicar o filtro da consulta"}
                        />

                        <ButtonComp
                            type="button"
                            onClick={handleClearFilter}
                            title="Limpar filtro"
                            buttonColor="#125578"
                            classnameIcon="fa-regular fa-circle-xmark"
                            hoverMessage={"Botão para limpar os campos de filtros preenchidos"}
                        />
                    </div>

                </div>
            </div>
        </form>
    );
};

export default FilterSolicitacaoUnidadeGerencia;
